// extracted by mini-css-extract-plugin
export default {"component":"PolarAreaChart_component__K+0qy","select":"PolarAreaChart_select__e3Fiw","selectOption":"PolarAreaChart_selectOption__V3D8K","polar":"PolarAreaChart_polar__NQWPQ"};